import { render, staticRenderFns } from "./PC_home.vue?vue&type=template&id=b04bf4be&scoped=true&"
import script from "./PC_home.vue?vue&type=script&lang=js&"
export * from "./PC_home.vue?vue&type=script&lang=js&"
import style0 from "./PC_home.vue?vue&type=style&index=0&id=b04bf4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04bf4be",
  null
  
)

export default component.exports